/**
 * @generated SignedSource<<5ef6fed889609df73bcc4587dc5f0110>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraVersionStatus = "ARCHIVED" | "RELEASED" | "UNRELEASED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type async_softwareReleasesLaunchCard_AsyncVersionStatus$data = {
  readonly status: JiraVersionStatus;
  readonly " $fragmentSpreads": FragmentRefs<"versionStatus_softwareReleasesLaunchCard">;
  readonly " $fragmentType": "async_softwareReleasesLaunchCard_AsyncVersionStatus";
};
export type async_softwareReleasesLaunchCard_AsyncVersionStatus$key = {
  readonly " $data"?: async_softwareReleasesLaunchCard_AsyncVersionStatus$data;
  readonly " $fragmentSpreads": FragmentRefs<"async_softwareReleasesLaunchCard_AsyncVersionStatus">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "async_softwareReleasesLaunchCard_AsyncVersionStatus",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "status"
      },
      "action": "THROW",
      "path": "status"
    },
    {
      "kind": "FragmentSpread",
      "name": "versionStatus_softwareReleasesLaunchCard"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "bbfb4743758d7a0f5d5885118b67b179";

export default node;
